import NavBarComponent from './nav-bar.component'
export default NavBarComponent
